<template>
    <div class="post-content entry-content" style="margin: 20px 0;text-align: center;">
        <img src="/res/QR2_wechat.png" width="150" height="150">
        <p style="font-size:16px;color:#424242;font-weight: bold;margin-bottom: 10px;">长按识别 关注公众号</p>
        <!-- <p style="font-size:16px;color:#424242;font-weight: bold;">关注后才能收到推送信息</p> -->
        <v-divider></v-divider>
    </div>
</template>

<script>
export default {
  name: 'Home',
  components: {
  },
  data: () => ({
  }),
  methods: {
    goFollow() {
      window.location.href = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI4MzEwNzk3NA==#wechat_redirect';
    }
  },
  created() {
  },
  mounted() {
  },
  activated() {
  },
  deactivated() {
  }
}

</script>

<style scoped>

</style>
